module.exports = __webpack_public_path__ + "img/ico-mail.ee1af749.svg";